import * as React from "react";
import { SpheraButtonEx } from "@sphera-cloud/component-ui-reactjs";

export function CommandCell(props) {
    const { dataItem } = props;
    const inEdit = dataItem[props.editField];
    const isNewItem = dataItem.isNew;
    const validRow = dataItem.localization && dataItem.localeId != 0;
    const onDeleteData = () => {
        props.remove(props.dataItem);
    };

    return (
        <td className="k-command-cell">
            <SpheraButtonEx
                className={!validRow && isNewItem ? "hidden mt-3 float-right mb-3 btn-primary" : "mt-3 float-right mb-3 btn-primary"}
                onClick={() =>
                    inEdit
                        ? isNewItem
                            ? props.add(dataItem)
                            : props.update(dataItem)
                        : props.edit(dataItem)
                }
                text={inEdit ? (isNewItem ? "Add" : "Update") : "Edit"}
            />
            <SpheraButtonEx
                className={inEdit && !isNewItem ? "hidden mt-3 float-right mb-3 btn-primary" : "mt-3 float-right mb-3 btn-primary"}
                onClick={() =>
                    inEdit ? props.discard(dataItem) : onDeleteData()
                }
                text={inEdit ? (isNewItem ? "Discard" : "Cancel") : "Remove"}
            />
        </td>
    );
};